import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-committee-field',
  standalone: false,
  templateUrl: './committee-field.component.html',
  styleUrls: ['./committee-field.component.scss'],
})
export class CommitteeFieldComponent implements OnInit {

  @Input() pageSpecificFormObject;
  @Input() committeeList;
  @Input() canUpdate;

  constructor() { }

  ngOnInit() { }

}
